import React, { useState } from 'react';
import Constants from '../utils/constants';
import SelectAutoWidth from './common/dropdown';
import { useNavigate } from 'react-router-dom';
import SettingsButton from './common/settingsButton';

import { getLocalData } from '../services/storageManager';

let pageHeaderStyle = {
    backgroundColor: '#EBEBEB',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    padding: '17px 74px 8px 91px',
    fontSize: 20,
    position: 'sticky',
    top: 0,
    zIndex: 99
}
let titleStyle = {
    fontWeight: 'bold',
    textAlign: 'center',
    paddingTop: 20
}


export default function Header({ heading, rightSection, dropDownvalue, handleDropDownChange, inputLabel, dropDownList }) {
    const navigate = useNavigate();
    const { ASSETS } = Constants;
    const teams = getLocalData('teams');

    if (!window.localStorage.getItem('accessToken'))
        navigate(Constants.ROUTES.AUTHENTICATION);

    return (
        <div style={pageHeaderStyle}>
            <div>
              <a href={`${window.location.origin}`}>  <img src={ASSETS.APP_LOGO.PATH} alt={ASSETS.APP_LOGO.ALT_TEXT} height={60} /></a>
            </div>
            <div>
                {heading && <div style={titleStyle}>{heading}</div>}
            </div>
            <div style={{display: 'flex'}}>
                {rightSection ? <div style={{ paddingTop: 20 }}>{rightSection}</div> : <SelectAutoWidth dropDownList={dropDownList} value={dropDownvalue} inputLabel={inputLabel} handleChange={handleDropDownChange} showOnly={teams}/>} 
            <SettingsButton/>
            </div>
        </div>)
}